import React from 'react';
export function StorytellingSlide() {
  const socialPosts = [{
    title: 'El mejor hotel en Aruba',
    thumbnail: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    likes: '451',
    views: '25.4K'
  }, {
    title: 'Literal living in my dream',
    thumbnail: 'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    likes: '430',
    views: '15.4K'
  }, {
    title: 'Aruba vibes',
    thumbnail: 'https://images.unsplash.com/photo-1552074284-5e84d87aee4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    likes: '267',
    views: '10.1K'
  }, {
    title: 'Embassy Suites',
    thumbnail: 'https://images.unsplash.com/photo-1560624052-449f5ddf0c31?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    likes: '345',
    views: '18.2K'
  }];
  return <div className="w-full bg-white" data-id="element-1580">
      <div className="max-w-5xl mx-auto" data-id="element-1581">
        <div className="flex flex-col md:flex-row gap-8 items-center mb-12" data-id="element-1582">
          <div className="w-full md:w-1/3" data-id="element-1583">
            <div className="w-32 h-32 rounded-full overflow-hidden mx-auto md:mx-0" data-id="element-1584">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/t9AcqBTZc97z7oLWTJi33G/unnamed_%284%29.png" alt="Fran" className="w-full h-full object-cover" data-id="element-1585" />
            </div>
          </div>
          <div className="w-full md:w-2/3" data-id="element-1586">
            <p className="text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-1587">
              Cada video que creo cuenta una historia única, ya sea una puesta
              de sol romántica para parejas, un viaje en solitario lleno de
              aventuras o una animada salida con amigos. Cada narrativa está
              diseñada para resonar con los espectadores, haciendo que se
              conecten y disfruten del contenido.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12" data-id="element-1588">
          {socialPosts.map((post, index) => <div key={index} className="bg-gray-50 rounded-lg overflow-hidden" data-id="element-1589">
              <div className="aspect-[9/16] relative" data-id="element-1590">
                <img src={post.thumbnail} alt={post.title} className="w-full h-full object-cover" data-id="element-1591" />
                <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/70 to-transparent text-white" data-id="element-1592">
                  <p className="text-white text-sm" data-id="element-1593">{post.title}</p>
                </div>
                <div className="absolute inset-0 flex items-center justify-center" data-id="element-1594">
                  <div className="w-12 h-12 rounded-full bg-red-600 flex items-center justify-center" data-id="element-1595">
                    <div className="w-0 h-0 border-t-[8px] border-t-transparent border-l-[16px] border-l-white border-b-[8px] border-b-transparent ml-1" data-id="element-1596"></div>
                  </div>
                </div>
              </div>
              <div className="p-4 flex justify-between" data-id="element-1597">
                <div className="flex items-center" data-id="element-1598">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-600 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1599">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" data-id="element-1600" />
                  </svg>
                  <span className="text-sm text-gray-700" data-id="element-1601">{post.likes}</span>
                </div>
                <div className="flex items-center" data-id="element-1602">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-600 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1603">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" data-id="element-1604" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" data-id="element-1605" />
                  </svg>
                  <span className="text-sm text-gray-700" data-id="element-1606">{post.views}</span>
                </div>
              </div>
            </div>)}
        </div>
        <div className="flex justify-center" data-id="element-1607">
          <a href="#" className="bg-black text-white px-8 py-3 text-sm uppercase hover:bg-gray-800 transition-colors rounded" data-id="element-1608">
            Ver Más Ejemplos
          </a>
        </div>
      </div>
    </div>;
}